
export default function Footer() {
    return (
        <footer id="footer">
            <div className="container py-2 text-center">
                    © Copyright <strong><span>Solution Points</span></strong>. All Rights Reserved
            </div>
        </footer>

    );
}